export const isEven = (numero: number) => {
  return numero % 2 === 0
}
